<template>
  <section
    class="privacy-policy"
    :class="{ loaded: pageLoaded }"
  >
    <div class="content">

      <!-- TITLE -->
      <h1 class="title animate-item">
        Aviso de Privacidad
      </h1>

      <!-- TEXT -->
      <div class="text">

        <section
          v-for="(section, index) in sections"
          :key="index"
          class="privacy-section animate-item"
          :style="{ transitionDelay: `${index * 80}ms` }"
        >
          <template v-if="section.title">
            <h2>{{ section.title }}</h2>
          </template>

          <template v-if="section.text">
            <p>{{ section.text }}</p>
          </template>

          <template v-if="section.list">
            <ul>
              <li
                v-for="(item, i) in section.list"
                :key="i"
              >
                {{ item }}
              </li>
            </ul>
          </template>

          <template v-if="section.contact">
            <div class="contact-box">
              <p>
                <strong>Email:</strong>
                info@raptoris.com
              </p>

              <p>
                <strong>Sitio web:</strong>
                raptoris.com
              </p>
            </div>
          </template>
        </section>

        <p class="updated animate-item">
          Última actualización: Mayo 2026
        </p>

      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "PrivacyPolicy",

  data() {
    return {
      pageLoaded: false,
      observer: null,

      sections: [
        {
          text:
            "En Raptoris, nos comprometemos a proteger la privacidad y seguridad de los datos personales de nuestros usuarios, clientes y visitantes de nuestro sitio web."
        },
        {
          title: "1. Responsable del tratamiento de datos",
          text:
            "Raptoris es responsable del uso y protección de los datos personales que nos proporciones a través de nuestro sitio web y formularios de contacto."
        },
        {
          title: "2. Datos que recopilamos",
          text:
            "Podemos recopilar los siguientes datos personales:",
          list: [
            "Nombre completo",
            "Correo electrónico",
            "Número telefónico (si es proporcionado)",
            "Información incluida en formularios de contacto",
            "Datos técnicos de navegación y uso del sitio"
          ]
        },
        {
          title: "3. Finalidad del uso de datos",
          text:
            "La información recopilada será utilizada para:",
          list: [
            "Responder solicitudes de contacto o cotizaciones",
            "Brindar soporte e información sobre servicios",
            "Mejorar la experiencia del usuario en el sitio web",
            "Dar seguimiento a solicitudes comerciales",
            "Cumplir obligaciones legales aplicables"
          ]
        },
        {
          title: "4. Protección de la información",
          text:
            "Implementamos medidas de seguridad administrativas, técnicas y organizativas para proteger tus datos personales contra acceso no autorizado, pérdida, alteración o divulgación indebida."
        },
        {
          title: "5. Compartición de datos",
          text:
            "Raptoris no vende ni comparte información personal con terceros sin autorización del usuario, excepto cuando sea requerido por ley o autoridad competente."
        },
        {
          title: "6. Uso de cookies y tecnologías similares",
          text:
            "Nuestro sitio puede utilizar cookies o tecnologías similares para mejorar la experiencia de navegación, analizar tráfico y optimizar funcionalidades del sitio web."
        },
        {
          title: "7. Derechos del usuario",
          text:
            "Como titular de tus datos personales, puedes solicitar el acceso, corrección, actualización o eliminación de tu información enviando una solicitud a nuestro correo de contacto."
        },
        {
          title: "8. Cambios al aviso de privacidad",
          text:
            "Nos reservamos el derecho de modificar o actualizar este aviso de privacidad en cualquier momento. Los cambios serán publicados en esta misma sección del sitio web."
        },
        {
          title: "9. Contacto",
          text:
            "Si tienes dudas relacionadas con este aviso de privacidad o el tratamiento de tus datos, puedes contactarnos mediante:",
          contact: true
        }
      ]
    };
  },

  mounted() {
    requestAnimationFrame(() => {
      this.pageLoaded = true;
    });

    this.observer = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      {
        threshold: 0.15
      }
    );

    this.$nextTick(() => {
      document
        .querySelectorAll(".animate-item")
        .forEach(item => this.observer.observe(item));
    });
  },

  beforeUnmount() {
    this.observer?.disconnect();
  }
};
</script>

<style scoped>

/* PAGE */

.privacy-policy{
  min-height:100vh;
  padding:4rem 1.2rem;

  background:
    linear-gradient(
      135deg,
      #f4f7f5 0%,
      #dbe7e0 100%
    );

  opacity:0;
  transform:translateY(30px);

  transition:
    opacity .8s ease,
    transform .8s ease;
}

.privacy-policy.loaded{
  opacity:1;
  transform:translateY(0);
}

/* CONTAINER */

.content{
  max-width:1000px;
  margin:auto;

  background:rgba(255,255,255,.95);

  border-radius:28px;

  padding:3rem;

  box-shadow:
    0 15px 40px rgba(0,0,0,.08);

  backdrop-filter:blur(8px);
}

/* ANIMATION */

.animate-item{
  opacity:0;
  transform:translateY(30px);

  will-change: transform, opacity;

  transition:
    opacity .7s ease,
    transform .7s ease;
}

.animate-item.visible{
  opacity:1;
  transform:translateY(0);
  will-change: auto;
}

/* TITLE */

.title{
  text-align:center;
  font-size:2.5rem;
  font-weight:700;
  margin-bottom:2rem;
  color:#0f172a;
}


/* SECTIONS */

.privacy-section{
  margin-bottom:2rem;
}

.text{
  color:#334155;
  line-height:1.9;
  font-size:1rem;
}

.text h2{
  margin-bottom:.8rem;

  color:#064e3b;

  font-size:1.35rem;
  font-weight:700;
}

.text p{
  margin-bottom:1rem;
}

.text ul{
  padding-left:1.5rem;
}

.text li{
  margin-bottom:.6rem;
}

/* CONTACT */

.contact-box{
  margin-top:1rem;

  padding:1.2rem;

  border-radius:16px;

  background:
    linear-gradient(
      135deg,
      rgba(6,78,59,.06),
      rgba(15,118,110,.08)
    );

  border:1px solid rgba(15,118,110,.12);
}

/* UPDATED */

.updated{
  margin-top:2rem;

  text-align:right;

  font-size:.9rem;
  color:#64748b;
}

/* RESPONSIVE */

@media (max-width:900px){

  .content{
    padding:2rem;
  }

  .title{
    font-size:2rem;
  }
}

@media (max-width:600px){

  .privacy-policy{
    padding:2rem 1rem;
  }

  .content{
    padding:1.5rem;
    border-radius:22px;
  }

  .title{
    font-size:1.7rem;
  }

  .text{
    font-size:.95rem;
  }

  .text h2{
    font-size:1.15rem;
  }
}

</style>